export default __webpack_public_path__ + "static/media/logo.b1ac9620.png";